import React from 'react';
import { useAnimatedToggle } from '@shared/Hooks/Ui/useMobileAnimatedToggle';
import styles from './FAQItem.module.css';
import DropdownButton from '@shared/Ui/Buttons/DropdownButton/DropdownButton';

interface FAQSectionProps {
    question: string;
    answer: string;
}

const FAQItem: React.FC<FAQSectionProps> = ({ question, answer }) => {
    const { isOpen, toggle, ref, maxHeight } = useAnimatedToggle(50);

    return (
        <div className={`${styles.accordionItem} ${isOpen ? styles.open : ''}`}>
            <div className={styles.accordionHeader} onClick={toggle}>
                <div>{question}</div>
                <DropdownButton
                    isOpen={isOpen}
                    extraClassName={styles.btn}
                    iconStroke={'#1E1E1E'}
                />
            </div>
            <div
                ref={ref}
                className={`${styles.accordionBody} ${isOpen ? styles.openBody : styles.closedBody}`}
                style={{ maxHeight }}
            >
                <div className={styles.accordionText}>{answer}</div>
            </div>
        </div>
    );
};

export default FAQItem;
